//From https://stackoverflow.com/a/55837025
function erfcinv(p) {
    var j = 0;
    var x, err, t, pp;
    if (p >= 2)
      return -100;
    if (p <= 0)
      return 100;
    pp = (p < 1) ? p : 2 - p;
    t = Math.sqrt(-2 * Math.log(pp / 2));
    x = -0.70711 * ((2.30753 + t * 0.27061) /
      (1 + t * (0.99229 + t * 0.04481)) - t);
    for (; j < 2; j++) {
      err = erfc(x) - pp;
      x += err / (1.12837916709551257 * Math.exp(-x * x) - x * err);
    }
    return (p < 1) ? x : -x;
  }
  
  function erfc(x) {
    return 1 - erf(x);
  }

  function erf(x) {
    var cof = [-1.3026537197817094, 6.4196979235649026e-1, 1.9476473204185836e-2,
      -9.561514786808631e-3, -9.46595344482036e-4, 3.66839497852761e-4,
      4.2523324806907e-5, -2.0278578112534e-5, -1.624290004647e-6,
      1.303655835580e-6, 1.5626441722e-8, -8.5238095915e-8,
      6.529054439e-9, 5.059343495e-9, -9.91364156e-10,
      -2.27365122e-10, 9.6467911e-11, 2.394038e-12,
      -6.886027e-12, 8.94487e-13, 3.13092e-13,
      -1.12708e-13, 3.81e-16, 7.106e-15,
      -1.523e-15, -9.4e-17, 1.21e-16,
      -2.8e-17
    ];
    var j = cof.length - 1;
    var isneg = false;
    var d = 0;
    var dd = 0;
    var t, ty, tmp, res;

    if (x < 0) {
      x = -x;
      isneg = true;
    }

    t = 2 / (2 + x);
    ty = 4 * t - 2;

    for (; j > 0; j--) {
      tmp = d;
      d = ty * d - dd + cof[j];
      dd = tmp;
    }

    res = t * Math.exp(-x * x + 0.5 * (cof[0] + ty * d) - dd);
    return isneg ? res - 1 : 1 - res;
  }

  function inv(p, mean, std) {
    return (-1.41421356237309505 * std * erfcinv(2 * p) + mean);
  }
  //original code
  const MonteCarloConversion = (mean, sd, initialInvestment, years, iterations) => {
    const monteCarloFinal = []; //array to hold the Monte Carlo simulation
  //This set of double for loops handles the Monte Carlo simulation.
    for (let j = 0; j < years; j++) {
      const monteCarlo = [];
      for (let i = 0; i < iterations; i++) {
        const p = Math.random();
        if (j < 1) {
          monteCarlo.push(parseFloat((initialInvestment*(1+inv(p, mean, sd))).toFixed(2)));
        } 
        else {
          monteCarlo.push(parseFloat((monteCarloFinal[j-1][i]*(1+inv(p, mean, sd))).toFixed(2)));
        }
      }
      monteCarloFinal.push(monteCarlo);
  
    }
    const lastYear = monteCarloFinal[monteCarloFinal.length-1];
  //sort monteCarloFinal into assending order by year
    lastYear.sort(function(a,b){return a-b});
  //Create the percentile returns
    const percentiles = [0.1, 0.25, 0.50, 0.75, 0.9]; //the percentiles to show on the graph
    const percentileReturns = []; //array to hold the returns for each percentile
  
    for (let i = 0; i < percentiles.length; i++){
        let index = lastYear.length*percentiles[i];
        percentileReturns.push(lastYear[index]);
    }
    const percentileRate = []; //stores the rates of return over 20 years for each percentile
    for (let i = 0; i < percentileReturns.length; i++){
      let rate = (percentileReturns[i]/initialInvestment)**(1/years)-1;
      percentileRate.push(rate);
    }
  
    //convert the initial investment and the percentile return into graph data
    const graphData = []; //array to store the graphing data
    for (let i = 0; i < percentileRate.length; i++){
      const tempGraphData = [];
      for (let j = 0; j < years; j++){
        if(j < 1) {
          tempGraphData.push(parseFloat(initialInvestment*(1+percentileRate[i])).toFixed(2));
        }
        else{
          tempGraphData.push(parseFloat(tempGraphData[j-1]*(1+percentileRate[i])).toFixed(2));
        }
        
      }
      graphData.push(tempGraphData);
    }
    graphData.push(initialInvestment);
    const median = graphData[2].slice()
    graphData.push(median);
    return graphData;
  }
  export default MonteCarloConversion;


// WEBPACK FOOTER //
// ./src/utilities/CyMonteCarloConversion.js